/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { ModelsAdminStationOrderUpdateInput } from "../../entities/models/AdminStationOrderUpdateInput";
import { z } from "zod/v4";

export const modelsAdminStationOrderUpdateInputSchema = z.object({
    "station_ids": z.array(z.int())
    }) as unknown as z.ZodType<ModelsAdminStationOrderUpdateInput>